var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaypalBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50.752 42.126 c -0.191 0 -0.327 0.187 -0.269 0.369 l 2.646 8.212 l -2.393 3.87 c -0.116 0.188 0.019 0.431 0.24 0.431 h 2.828 c 0.164 0 0.317 -0.086 0.402 -0.227 l 7.391 -12.226 c 0.113 -0.188 -0.022 -0.428 -0.242 -0.428 h -2.828 c -0.166 0 -0.32 0.088 -0.404 0.231 l -2.909 4.912 l -1.477 -4.875 c -0.048 -0.159 -0.195 -0.267 -0.36 -0.267 L 50.752 42.126 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,48,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 87.11 37.841 c -0.185 0 -0.343 0.135 -0.372 0.318 l -2.145 13.596 c -0.03 0.19 0.099 0.368 0.289 0.398 c 0.018 0.003 0.036 0.004 0.055 0.004 h 2.543 c 0.185 0 0.343 -0.135 0.372 -0.318 l 2.144 -13.597 c 0.03 -0.19 -0.1 -0.368 -0.29 -0.398 c -0.018 -0.003 -0.035 -0.004 -0.053 -0.004 H 87.11 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,112,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.581 37.841 c -0.338 0 -0.626 0.246 -0.679 0.581 L 5.773 45.58 c 0.053 -0.334 0.341 -0.581 0.679 -0.581 H 9.76 c 3.328 0 6.153 -2.428 6.669 -5.719 c 0.038 -0.246 0.06 -0.494 0.065 -0.742 c -0.846 -0.444 -1.84 -0.697 -2.928 -0.697 L 7.581 37.841 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,28,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.494 38.539 c -0.005 0.249 -0.027 0.497 -0.065 0.742 C 15.913 42.571 13.088 45 9.76 45 H 6.453 c -0.338 0 -0.627 0.246 -0.679 0.581 l -1.038 6.578 l -0.65 4.127 c -0.048 0.304 0.159 0.59 0.463 0.639 c 0.029 0.005 0.059 0.007 0.088 0.007 h 3.59 c 0.338 0 0.626 -0.246 0.679 -0.581 l 0.946 -5.997 c 0.053 -0.334 0.341 -0.581 0.68 -0.581 h 2.113 c 3.328 0 6.153 -2.428 6.669 -5.719 C 19.68 41.718 18.504 39.593 16.494 38.539 L 16.494 38.539 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,112,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.503 33.07 c -0.338 0 -0.627 0.246 -0.679 0.58 L 0.007 51.512 c -0.053 0.339 0.209 0.646 0.552 0.646 h 4.177 l 1.037 -6.578 l 1.129 -7.158 c 0.053 -0.334 0.341 -0.58 0.679 -0.581 h 5.984 c 1.089 0 2.082 0.254 2.928 0.697 c 0.058 -2.996 -2.414 -5.469 -5.813 -5.469 H 3.503 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,48,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 68.343 37.841 h -4.805 c -0.185 0 -0.343 0.134 -0.372 0.318 l -2.144 13.597 c -0.03 0.19 0.1 0.368 0.29 0.398 c 0.018 0.003 0.036 0.004 0.054 0.004 h 2.543 c 0.185 0 0.343 -0.135 0.372 -0.318 l 0.63 -3.993 c 0.029 -0.183 0.186 -0.318 0.372 -0.318 h 2.312 c 2.701 0 4.994 -1.971 5.412 -4.641 C 73.429 40.195 71.325 37.847 68.343 37.841 z M 69.722 42.769 c -0.157 0.996 -0.927 1.729 -2.4 1.729 h -1.883 l 0.571 -3.621 h 1.85 C 69.383 40.877 69.879 41.775 69.722 42.769 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,112,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.584 37.841 h -4.805 c -0.185 0 -0.343 0.134 -0.372 0.318 l -2.144 13.597 c -0.03 0.19 0.1 0.368 0.29 0.398 c 0.018 0.003 0.036 0.004 0.054 0.004 h 2.543 c 0.185 0 0.343 -0.135 0.372 -0.318 l 0.63 -3.993 c 0.029 -0.183 0.186 -0.318 0.372 -0.318 h 2.312 c 2.701 0 4.994 -1.971 5.413 -4.641 C 38.669 40.195 36.566 37.847 33.584 37.841 z M 34.962 42.769 c -0.157 0.996 -0.927 1.729 -2.4 1.729 H 30.68 l 0.571 -3.621 h 1.85 C 34.623 40.877 35.119 41.775 34.962 42.769 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,48,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.078 42.131 c -0.018 -0.003 -0.036 -0.004 -0.055 -0.004 h -2.414 c -0.185 0 -0.343 0.135 -0.371 0.318 l -0.079 0.501 c 0 0 -1.054 -1.151 -2.981 -1.144 h 0 c -0.642 0.002 -1.381 0.134 -2.21 0.479 c -1.902 0.793 -2.816 2.432 -3.204 3.627 c 0 0 -1.234 3.645 1.556 5.648 c 0 0 2.587 1.928 5.5 -0.119 l -0.05 0.32 c -0.03 0.19 0.1 0.368 0.29 0.398 c 0.018 0.003 0.036 0.004 0.054 0.004 h 2.414 c 0.185 0 0.343 -0.135 0.372 -0.318 l 1.469 -9.311 C 84.397 42.339 84.268 42.161 84.078 42.131 z M 80.476 47.273 c -0.211 1.335 -1.306 2.319 -2.71 2.319 c -0.277 0 -0.53 -0.038 -0.758 -0.111 c -1.041 -0.334 -1.635 -1.335 -1.465 -2.419 c 0.211 -1.335 1.309 -2.319 2.714 -2.319 v 0 c 0.277 0 0.531 0.038 0.758 0.111 C 80.057 45.188 80.647 46.188 80.476 47.273 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,112,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.42,41.8 43.42,41.8 43.42,41.8 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,48,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.317 42.131 c -0.018 -0.003 -0.036 -0.004 -0.054 -0.004 h -2.414 c -0.185 0 -0.343 0.135 -0.372 0.318 l -0.079 0.501 c 0 0 -1.054 -1.151 -2.981 -1.144 c -0.642 0.002 -1.381 0.134 -2.21 0.479 c -1.902 0.793 -2.816 2.432 -3.204 3.627 c 0 0 -1.235 3.645 1.555 5.648 c 0 0 2.588 1.928 5.5 -0.119 l -0.05 0.32 c -0.03 0.19 0.1 0.368 0.29 0.398 c 0.018 0.003 0.036 0.004 0.053 0.004 h 2.414 c 0.185 0 0.343 -0.135 0.372 -0.318 l 1.468 -9.311 C 49.637 42.339 49.507 42.161 49.317 42.131 z M 45.717 47.273 c -0.211 1.335 -1.306 2.319 -2.71 2.319 c -0.277 0 -0.53 -0.038 -0.758 -0.111 c -1.041 -0.334 -1.635 -1.335 -1.465 -2.419 c 0.211 -1.335 1.309 -2.319 2.714 -2.319 v 0 c 0.277 0 0.531 0.038 0.758 0.111 C 45.297 45.188 45.888 46.188 45.717 47.273 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,48,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalBlueLogo);
export default __webpack_public_path__ + "static/media/paypal-blue-logo.800688c3606bf367c1f81ee9692cd9dc.svg";
export { ForwardRef as ReactComponent };